var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/es-get-iterator/~/isarray/index.js
// module id = 678
// module chunks = 0